import * as constants from '../constants/CONSTANT';

const SCRIPT_ID = 'ibs-google-maps-script';
const pendingCallbacks = [];
let loadStarted = false;

function runPendingCallbacks() {
  if (!window.google?.maps) return;
  const queue = pendingCallbacks.splice(0, pendingCallbacks.length);
  queue.forEach((cb) => {
    try {
      cb();
    } catch (error) {
      console.error('Google Maps init callback error:', error);
    }
  });
}

/**
 * Loads Maps JS API once and runs callback when ready.
 * Safe across route changes — callbacks only run when registered.
 */
export function whenGoogleMapsReady(callback) {
  if (window.google?.maps) {
    callback();
    return;
  }

  pendingCallbacks.push(callback);

  if (loadStarted) return;
  loadStarted = true;

  const existingScript = document.getElementById(SCRIPT_ID);
  if (existingScript) {
    const waitForMaps = setInterval(() => {
      if (window.google?.maps) {
        clearInterval(waitForMaps);
        runPendingCallbacks();
      }
    }, 50);
    return;
  }

  window.__ibsGoogleMapsReady = () => {
    runPendingCallbacks();
  };

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `https://maps.googleapis.com/maps/api/js?key=${constants.GOOGLE_MAPS_API_KEY}&callback=__ibsGoogleMapsReady`;
  document.body.appendChild(script);
}

/** Returns map instance or null if element is not on current page. */
export function createMap(elementId, mapProp) {
  const el = document.getElementById(elementId);
  if (!el || !window.google?.maps) {
    return null;
  }
  return new window.google.maps.Map(el, mapProp);
}
